export let SemPr20_1_6 = {
	"name": "SemPr20_1_6",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Каков минимальный возраст, позволяющий лицу вступить в брак на территории РФ?",
				"correct_ans": [
					{
						"ans": "Возраст, определенный законом субъекта РФ",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Четырнадцать лет - возраст возникновения частичной гражданской дееспособности, не влияющей в рассматриваемом случае на возникновение дееспособности семейной, в том числе на возникновение права на вступление в брак.",
						"ans": "14 лет",
						"score": 0
					},
					{
						"comm": "Восемнадцать лет - это брачный возраст, т. е. возраст, по наступлении которого лицо вправе свободно вступить в брак, при соблюдении иных условий его заключения. В вопросе же речь идет о минимальном возрасте, позволяющем вступить в брак, т. е. о возрасте, с наступлением которого лицо может вступить в брак с разрешения уполномоченных органов либо с соблюдением иных, дополнительных к условиям заключения брака, требований, \"компенсирующих \"недостижение брачного возраста.",
						"ans": "18 лет",
						"score": 0
					},
					{
						"comm": "Закон содержит единый подход к решению поставленного вопроса вне зависимости от принадлежности брачующихся к мужскому или женскому полу.",
						"ans": "Для мужчин - 16 лет, для женщин - 14 лет",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "По смыслу абз. 2 п. 2 ст. 13 СК РФ минимальный возраст для вступления в брак лица, не достигшего возраста 16 лет, в виде исключения и при наличии особых обстоятельств может быть установлен законом субъекта РФ"
}

export let SemPr20_1_156 = {
	"name": "SemPr20_1_156",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Основаниями (основанием) освобождения совершеннолетнего ребенка от обязанности по уплате алиментов родителям являются следующие:",
				"correct_ans": [
					{
						"ans": "Нетрудоспособность совершеннолетнего ребенка",
						"score": 12
					},
					{
						"ans": "Уклонение родителей от выполнения родительских обязанностей",
						"score": 12
					},
					{
						"ans": "Лишение родителя родительских прав",
						"score": 12
					},
					{
						"ans": "Совершение родителем умышленного преступления против ребенка",
						"score": 12
					},
					{
						"ans": "Недостойное поведение родителя в семье",
						"score": 12
					}
				],
				"wrong_ans": [
					{
						"comm": "Обязанность по выплате средств на содержание родителя не зависит от достаточности либо недостаточности средств у ребенка, хотя, безусловно, может повлиять на размер предоставляемых средств.",
						"ans": "Недостаточность средств, плохое материальное положение ребенка",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Основания освобождения детей от уплаты содержания дееспособным родителям вытекают из п. 1 ст. 87 СК РФ, а также п. 2 ст. 119 СК РФ",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let SemPr20_1_173 = {
	"name": "SemPr20_1_173",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Сохраняется ли за ребенком, родители которого умерли после его усыновления, право на получение пенсий или пособий в связи со смертью родителей?",
				"correct_ans": [
					{
						"ans": "Нет, не сохраняются",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Да сохраняются",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "По смыслу ст. 138 СК РФ право на получение пенсии и пособия по случаю смерти родителей предоставляется несовершеннолетним детям, не усыновленным к моменту смерти родителей. Если родители умерли после усыновления ребенка, то ребенок не приобретает указанного права"
}

export let SemPr20_1_26 = {
	"name": "SemPr20_1_26",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Право требовать расторжения в административном порядке (в органе ЗАГС РФ) брака с лицом, виновным в совершении преступления и осужденным к лишению свободы на срок свыше трех лет, принадлежит:",
				"correct_ans": [
					{
						"ans": "Супругу лица, осужденного к лишению свободы",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Норма, допускающая расторжение брака в органе ЗАГС РФ в рассматриваемой ситуации, - это своего рода защита интересов супруга, не желающего состоять в браке с лицом, признанным виновным в совершении преступления.",
						"ans": "Обоим супругам",
						"score": 0
					},
					{
						"comm": "Норма, допускающая расторжение брака в органе ЗАГС РФ в рассматриваемой ситуации, - это своего рода защита интересов супруга, не желающего состоять в браке с лицом, признанным виновным в совершении преступления.",
						"ans": "Лицу, осужденному к лишению свободы",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "В силу ст. 19 СК РФ право требовать расторжения брака в упрощенном, административном, порядке (в органе ЗАГС РФ) принадлежит исключительно супругу лица, осужденного к лишению свободы"
}

export let SemPr20_1_77 = {
	"name": "SemPr20_1_77",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Какие (какое) из перечисленных имущественных прав возникают у пережившего супруга, если в завещании умершего супруга-наследодателя он не упомянут в качестве наследника?",
				"correct_ans": [
					{
						"ans": "Право на долю в общем имуществе, нажитом в период брака с наследодателем",
						"score": 30
					},
					{
						"ans": "Право на обязательную долю, если переживший супруг нетрудоспособен",
						"score": 30
					}
				],
				"wrong_ans": [
					{
						"ans": "Ни одно из перечисленных прав",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Как следует из ст. 1150 ГК РФ, вне зависимости от того, является ли переживший супруг наследником или нет, он обладает правом на долю в имуществе, совместно нажитом с умершим супругом. Кроме того, переживший супруг, не упомянутый в завещании в качестве наследника, в случаях, предусмотренных ст. 1149 ГК РФ, имеет право на обязательную долю в наследстве. Одним из таких случаев является нетрудоспособность пережившего супруга. Иное может быть предусмотрено совместным завещанием супругов или наследственным договором. ",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let SemPr20_1_59 = {
	"name": "SemPr20_1_59",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Под соглашением о разделе имущества понимается:",
				"correct_ans": [
					{
						"comm": "Именно такое понимание соглашения о разделе имущества вытекает из ст. 38 СК РФ.",
						"ans": "Соглашение между супругами (бывшими супругами) о разделе общего имущества супругов, нажитого к моменту заключения соглашения",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Соглашение о разделе имущества заключается только в отношении имущества, имеющегося на момент его заключения. Более того, такое соглашение может заключаться не только на случай прекращения брака, но и по требованию одного из супругов в любой момент в период брака. По смыслу ст. 38 СК РФ под соглашением о разделе имущества следует понимать соглашение между супругами или бывшими супругами по поводу раздела имущества, совместно нажитого к моменту заключения соглашения. Это соглашение подлежит обязательному нотариальному удостоверению.",
						"ans": "Соглашение между супругами (будущими супругами) об условиях и порядке раздела имущества в случае прекращения брака, распространяющееся как на имущество, приобретенное к моменту заключения соглашения, так и на имущество, которое будет приобретено в будущем",
						"score": 0
					},
					{
						"comm": "Кредитор не может являться стороной соглашения о разделе имущества. Раздел имущества - право его собственников, а не их кредиторов.",
						"ans": "Соглашение между супругами и кредитором одного из супругов о выделе доли супруга в целях обращения на нее взыскания в случае неисполнения обязательства такого супруга перед кредитором",
						"score": 0
					},
					{
						"comm": "В данном случае Вы ошибочно отождествляете понятие соглашения о разделе имущества и понятие мирового соглашения. По смыслу ст. 38 СК РФ под соглашением о разделе имущества следует понимать соглашение между супругами или бывшими супругами по поводу раздела имущества, совместно нажитого к моменту заключения соглашения.",
						"ans": "Мировое соглашение между супругами (бывшими супругами) о разделе имущества, нажитого к моменту подачи искового заявления о разделе имущества (либо о расторжении брака и разделе имущества)",
						"score": 0
					},
					{
						"comm": "По смыслу ст. 38 СК РФ под соглашением о разделе имущества следует понимать соглашение между супругами или бывшими супругами по поводу раздела имущества, совместно нажитого к моменту заключения соглашения.",
						"ans": "Ни один из вариантов ответа не является правильным",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let SemPr20_1_30 = {
	"name": "SemPr20_1_30",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Какие из перечисленных ниже вопросов суд обязан разрешить при рассмотрении дела о расторжении брака, если суду не было представлено никаких соглашений между супругами?",
				"correct_ans": [
					{
						"ans": "О том, с кем из родителей будет проживать ребенок",
						"score": 30
					},
					{
						"ans": "С кого и в каком размере взыскиваются алименты на детей",
						"score": 30
					}
				],
				"wrong_ans": [
					{
						"ans": "О разделе совместно нажитого супругами имущества",
						"score": 0
					},
					{
						"ans": "О размере содержания, выплачиваемого одному из супругов, имеющего право на получение содержания",
						"score": 0
					},
					{
						"ans": "По всем перечисленным вопросам",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Согласно п. 2 ст. 24 СК РФ при отсутствии соответствующего соглашения суд обязан принять решение по вопросам о месте проживания ребенка (1) и о выплате средств на содержание ребенка (2), даже если требования об этом не заявлено ни одной из сторон. Остальные вопросы суд разрешает исключительно по требованию хотя бы одного из супругов. См. также п. 11 Постановления Пленума ВС РФ № 15 от 05. 11. 1998, п. 4 Постановления Пленума ВС РФ № 10 от 27. 05. 1998",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let SemPr20_1_47 = {
	"name": "SemPr20_1_47",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Какие из перечисленных прав принадлежат добросовестному супругу, признанному таковым судом при рассмотрении вопроса о признании брака недействительным:",
				"correct_ans": [
					{
						"comm": "Это лишь единственное среди многочисленных прав, предоставленных добросовестному супругу.",
						"ans": "Право на возмещение морального вреда",
						"score": 12
					},
					{
						"comm": "Это лишь единственное среди многочисленных прав, предоставленных добросовестному супругу.",
						"ans": "Право на сохранение фамилии, избранной при заключении брака",
						"score": 12
					},
					{
						"comm": "Это лишь единственное среди многочисленных прав, предоставленных добросовестному супругу.",
						"ans": "Право на возмещение материального вреда",
						"score": 12
					},
					{
						"comm": "Это лишь единственное среди многочисленных прав, предоставленных добросовестному супругу.",
						"ans": "Право на получение содержания по основаниям, предусмотренным для бывших супругов",
						"score": 12
					},
					{
						"comm": "Это лишь единственное среди многочисленных прав, предоставленных добросовестному супругу.",
						"ans": "Право требовать раздела имущества в соответствии с избранным режимом имущества",
						"score": 12
					}
				],
				"wrong_ans": []
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Согласно ст. 30 СК РФ при вынесении решения о признании брака недействительным суд вправе признать за добросовестным супругом право на получение от другого супруга содержания (ст. 90, 91 СК РФ), а в отношении раздела имущества, приобретенного совместно до момента признания брака недействительным, вправе применить положения СК РФ о совместной собственности супругов (34, 38, 39 СК РФ), а также признать действительным брачный договор полностью или частично. Добросовестный супруг вправе требовать возмещения причиненного ему материального и морального вреда, а также сохранить фамилию, избранную им при государственной регистрации заключения брака",
	"EstPos": "max",
	"EstNeg": "min",
	"EstMix": "min"
}

export let SemPr20_1_45 = {
	"name": "SemPr20_1_45",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Верно ли утверждение: при наличии обстоятельств, устраняющих недействительность брака, суд не может признать брак недействительным?",
				"correct_ans": [
					{
						"ans": "Не верно, за исключением требований о признании фиктивного брака недействительным",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Да, верно",
						"score": 0
					},
					{
						"ans": "Нет, не верно",
						"score": 0
					},
					{
						"ans": "Верно, за исключением требований о признании недействительным брака, заключенного между лицами, состоящими в запрещенной степени родства",
						"score": 0
					},
					{
						"ans": "Не верно, за исключением требований о признании недействительным брака с несовершеннолетним",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Согласно ст. 29 СК РФ наличие устраняющих недействительность брака обстоятельств предоставляет суду право отказать в признании брака недействительным, а не является его обязанностью. Единственное исключение из этого правила предусмотрено п. 3 ст. 29 СК РФ: суд не может признать брак фиктивным, если к моменту рассмотрения дела лица, заключившие такой брак, фактически создали семью"
}

export let SemPr20_1_27 = {
	"name": "SemPr20_1_27",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Каков порядок расторжения брака с лицом, отсутствующим в месте своего жительства более одного года, о котором нет никаких сведений о месте его пребывания?",
				"correct_ans": [
					{
						"ans": "В административном порядке (в органе ЗАГС РФ), если лицо признано безвестно отсутствующим; в остальных случаях - в судебном порядке",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Только в судебном порядке",
						"score": 0
					},
					{
						"ans": "Только в административном порядке (в органе ЗАГС РФ)",
						"score": 0
					},
					{
						"comm": "На усмотрение супруга предоставлено решение вопроса о признании другого супруга безвестно отсутствующим (если данный вопрос не решен по требованию иных заинтересованных лиц), а не о выборе порядка расторжения брака с ним.",
						"ans": "В судебном либо административном (в органе ЗАГС РФ) порядке по усмотрению супруга",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "По смыслу п. 2 ст. 19 СК РФ брак может быть расторгнут в органе ЗАГС РФ только в том случае, если имеется вступившее в законную силу решение суда о признании одного из супругов безвестно отсутствующим. При отсутствии такого решения брак расторгается в судебном порядке. См. п. 5 Постановления Пленума ВС РФ № 15 от 05. 11. 1998"
}

export let SemPr20_1_83 = {
	"name": "SemPr20_1_83",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "В каком порядке осуществляется государственная регистрация имени ребенка, если имя не включено в справочник личных имен либо используется в иностранном государстве?",
				"correct_ans": [
					{
						"ans": "Государственная регистрация имени осуществляется исключительно по соглашению родителей",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Получения разрешения каких-либо государственных органов или органов местного самоуправления на присвоение ребенку имени не требуется.",
						"ans": "Государственная регистрация имени осуществляется на основании разрешения органа опеки и попечительства",
						"score": 0
					},
					{
						"comm": "Уведомления органов опеки и попечительства об избранном ребенку имени не требуется.",
						"ans": "Государственная регистрация имени осуществляется по соглашению родителей с последующим уведомлением органа опеки и попечительства",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "В соответствии с п. 2 ст. 58 СК РФ, п. 2 ст. 18 Федерального закона «Об актах гражданского состояния» выбор имени ребенка осуществляется исключительно его родителями"
}

export let SemPr20_1_136 = {
	"name": "SemPr20_1_136",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Влечет ли за собой прекращение договора о приемной семье прекращение соглашения об уплате алиментов, заключенного приемными родителями от имени малолетнего подопечного?",
				"correct_ans": [
					{
						"ans": "Нет, не влечет",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Да, влечет",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Прекращение договора о приемной семье не может само по себе повлечь прекращение соглашения об уплате алиментов, надлежаще совершенного приемными родителями в рамках предоставленных им полномочий от имени и в интересах малолетнего подопечного"
}

export let SemPr20_1_81 = {
	"name": "SemPr20_1_81",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "В течение какого периода времени после отмены усыновления бывший усыновитель может быть привлечен к ответственности за причинение вреда ребенком?",
				"correct_ans": [
					{
						"ans": "После отмены решения об усыновлении бывший усыновитель не может быть привлечен к ответственности за причинение вреда ребенком (бывшим усыновленным)",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Закон (ст. 1075 ГК РФ) устанавливает трехлетний срок для привлечения к ответственности родителей, лишенных родительских прав, но не бывших усыновителей. Хотя вряд ли такая позиция законодателя верна, т. к. основанием возложения ответственности на родителей, лишенных родительских прав, является отсутствие (недостаточность) должного воспитания ребенка, что в полной мере может распространяться и на бывших усыновителей.",
						"ans": "В течение трех лет после отмены решения об усыновлении",
						"score": 0
					},
					{
						"comm": "Было бы несправедливо возлагать на бывших усыновителей, не участвовавших в воспитании ребенка после отмены усыновления, ответственность за вред, причиненный этим ребенком вплоть до его совершеннолетия. Более адекватной в рассматриваемом случае могла бы стать возможность привлечения бывших усыновителей к ответственности в течение определенного срока после отмены усыновления, если причинение вреда ребенком явилось следствием его ненадлежашего воспитания усыновителем.",
						"ans": "До совершеннолетия ребенка, в отношении которого отменено усыновление",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Согласно действующему законодательству бывшие усыновители не привлекаются к ответственности за вред, причиненный детьми (бывшими усыновленными)"
}

export let SemPr20_1_177 = {
	"name": "SemPr20_1_177",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Какое максимально допустимое количество детей может быть принято на воспитание в приемную семью, состоящую из супругов, двух детей по происхождению и одного усыновленного ребенка?",
				"correct_ans": [
					{
						"ans": "Не более 5",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Не установлено ограничений. Определяет орган местного самоуправления",
						"score": 0
					},
					{
						"ans": "Не более 7",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Общее количество детей в приемной семье, включая родных и усыновленных, не должно превышать, как правило, 8 человек. В рассматриваемом случае семья может взять на воспитание не более 5 детей. См. п. 3 Правил создания приемной семьи и осуществления контроля за условиями жизни и воспитания ребенка (детей) в приемной семье, утв. Постановлением Правительства РФ от 18.05.2009 № 423"
}

export let SemPr20_1_174 = {
	"name": "SemPr20_1_174",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Вправе ли усыновитель, усыновивший ребенка своей супруги в период брака, требовать отмены усыновления после расторжения брака с матерью ребенка?",
				"correct_ans": [
					{
						"ans": "Нет, не вправе",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Да, вправе",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Изменение отношений усыновителя с матерью ребенка не может стать безусловным основанием для отмены усыновления, поскольку при усыновлении усыновитель принял на себя обязанности перед усыновленным ребенком, а не перед его матерью"
}

export let SemPr20_1_197 = {
	"name": "SemPr20_1_197",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "В какой срок суд должен направить выписку из решения о восстановлении в родительских правах в орган опеки и попечительства?",
				"correct_ans": [
					{
						"ans": "В течение трех дней со дня вступления в законную силу этого решения",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Неверный ответ. СК РФ предусматривает направление такой выписки в органы опеки и попечительства в течение трех дней со дня вступления в законную силу этого решения ( п. 5 ст. 72).",
						"ans": "Суд не должен направлять эту выписку в органы опеки и попечительства",
						"score": 0
					},
					{
						"comm": "Неверный ответ. СК РФ предусматривает направление такой выписки в органы опеки и попечительства в течение трех дней со дня вступления в законную силу этого решения ( п. 5 ст. 72).",
						"ans": "В течение месяца со дня вынесения этого решения",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Суд направляет выписку из решения о восстановлении в родительских правах в орган опеки и попечительства по месту вынесения решения в течение трех дней со дня вступления в законную силу этого решения. См. п. 5 ст. 72 СК РФ"
}

export let SemPr20_1_20 = {
	"name": "SemPr20_1_20",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Основаниями (основанием) прекращения брака в РФ являются следующие обстоятельства:",
				"correct_ans": [
					{
						"ans": "Смерть одного из супругов",
						"score": 20
					},
					{
						"ans": "Расторжение брака",
						"score": 20
					},
					{
						"ans": "Объявление одного из супругов умершим",
						"score": 20
					}
				],
				"wrong_ans": [
					{
						"comm": "Признание одного из супругов безвестно отсутствующим не прекращает брак, а может стать основанием для его расторжения.",
						"ans": "Признание одного из супругов безвестно отсутствующим",
						"score": 0
					},
					{
						"comm": "Основное последствие признания брака недействительным - это не прекращение, а \"аннулирование\" брака, т. е. признание его несуществовавшим с момента заключения.",
						"ans": "Признание брака недействительным",
						"score": 0
					},
					{
						"ans": "Все перечисленные обстоятельства",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Как следует из ст. 16 СК РФ брак прекращается в следующих случаях: (1) смерть хотя бы одного из супругов, (2) объявление хотя бы одного из супругов умершим либо (3) расторжение брака",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let SemPr20_1_152 = {
	"name": "SemPr20_1_152",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "В какой срок руководитель воспитательного учреждения уведомляет орган опеки и попечительства о желании лиц взять на воспитание в семью ребенка, оставшегося без попечения родителей и находящегося в этом учреждении?",
				"correct_ans": [
					{
						"ans": "3-х рабочих дней со дня, когда стало известно, что ребенок может быть передан на воспитание в семью",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "14 дней после того, как ребенок был передан на воспитание в семью",
						"score": 0
					},
					{
						"ans": "Никаких сроков для уведомления закон не устанавливает",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Руководители образовательных организаций, медицинских организаций, организаций, оказывающих социальные услуги, или аналогичных организаций, в которых находятся дети, оставшиеся без попечения родителей, обязаны в течение трех рабочих дней со дня, когда им стало известно, что ребенок может быть передан на воспитание в семью, сообщить об этом в орган опеки и попечительства по месту нахождения учреждения. См. п. 2 ст. 122 СК РФ"
}

export let SemPr20_1_79 = {
	"name": "SemPr20_1_79",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Для исполнения каких (какого) из перечисленных требований взыскание налагается на общее имущество супругов, увеличенное за счет средств, полученных в результате совершения преступления одним из супругов",
				"correct_ans": [
					{
						"ans": "Возмещения имущественного вреда, причиненного имуществу в результате совершения преступления",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Привлечение лица к уголовной ответственности и назначение уголовного наказания носит индивидуальный характер и применяется исключительно в отношении лиц, признанных виновными в совершении преступления. Штраф, как вид уголовного наказания, уплачивается за счет имущества супруга, совершившего преступление.",
						"ans": "Уплаты штрафа (как меры наказания за совершение преступления)",
						"score": 0
					},
					{
						"comm": "Моральный вред возмещается причинителем вреда, за исключением предусмотренных законом случаев (п. 1 ст. 1064 ГК РФ, ст. 1100 ГК РФ), и за счет принадлежащего ему имущества. В данном случае моральный вред возмещается за счет имущества супруга, признанного виновным в совершении преступления (см. также п. 3 Постановления Пленума ВС РФ № 10 от 20. 12. 1994).",
						"ans": "Возмещения морального вреда за совершение преступления",
						"score": 0
					},
					{
						"comm": "Возмещение имущественного ущерба, причиненного жизни или здоровью лица, не может осуществляться за счет супружеского имущества, т. к. сам объект преступления (жизнь, здоровье личности) исключает условие возникновения общего обязательства супругов - увеличение совместно нажитого имущества в результате совершения преступления одним из супругов.",
						"ans": "Возмещения имущественного вреда, нанесенного жизни или здоровью в результате совершения преступления",
						"score": 0
					},
					{
						"ans": "Для исполнения любого из перечисленных требований",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Ст. 45 СК РФ, предусматривающая возможность наложения взыскания на общее имущество супругов, если один из них совершил преступление, применяется лишь для возмещения имущественного вреда, причиненного имуществу"
}

export let SemPr20_1_169 = {
	"name": "SemPr20_1_169",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Влечет ли восстановление дееспособности родителя отмену усыновления ребенка, усыновленного в период недееспособности родителя?",
				"correct_ans": [
					{
						"ans": "Влечет, если это отвечает интересам ребенка",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Нет, не влечет",
						"score": 0
					},
					{
						"comm": "Само по себе восстановление дееспособности родителя (решение суда о признании родителя по происхождению дееспособным) не отменяет усыновления.",
						"ans": "Да, влечет",
						"score": 0
					},
					{
						"comm": "Возражение усыновителей не препятствуют решению вопроса об отмене усыновления.",
						"ans": "Влечет в случае отсутствия возражений со стороны усыновителей",
						"score": 0
					},
					{
						"comm": "Возражение усыновителей не препятствуют решению вопроса об отмене усыновления.",
						"ans": "Влечет, если это отвечает интересам ребенка, при отсутствии возражений со стороны усыновителей",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Не закрепляя исчерпывающего перечня оснований для отмены усыновления, закон (п. 2 ст. 141 СК РФ) допускает отмену усыновления исходя из интересов ребенка и с учетом его мнения. В качестве одного из оснований отмены усыновления судебная практика называет невозможность ребенка забыть родителей, что вполне применимо и в рассматриваемом случае. См. п. 19 Постановления ВС РФ № 8 от 20. 04. 2006"
}

export let SemPr20_1_179 = {
	"name": "SemPr20_1_179",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Какие (какая) из перечисленных форм устройства могут применяться в отношении детей, одинокая мать (отец) которых временно не имеет возможности осуществлять родительские права?",
				"correct_ans": [
					{
						"ans": "Помещение в учреждение для детей сирот и детей, оставшихся без попечения родителей",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Усыновление",
						"score": 0
					},
					{
						"ans": "Ни одна из предусмотренных форм устройства",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Дети одиноких матерей (отцов), безработных, беженцев или вынужденных переселенцев могут временно, как правило, на срок до одного года, приниматься в организации для детей-сирот и детей, оставшихся без попечения родителей. См. подп. 2 п. 3 ст. 14 Федерального закона «Об основах системы профилактики безнадзорности и правонарушений несовершеннолетних»"
}

export let SemPr20_1_120 = {
	"name": "SemPr20_1_120",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Решение об отобрании ребенка при непосредственной угрозе его жизни или здоровью может быть принято в отношении следующих (следующего) лиц:",
				"correct_ans": [
					{
						"ans": "Родителей",
						"score": 12
					},
					{
						"ans": "Усыновителей",
						"score": 12
					},
					{
						"ans": "Опекунов",
						"score": 12
					},
					{
						"ans": "Попечителей",
						"score": 12
					},
					{
						"ans": "Приемных родителей",
						"score": 12
					}
				],
				"wrong_ans": [
					{
						"ans": "Только родителей или усыновителей",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Исходя из ст. 77 СК РФ, отобрание ребенка при непосредственной угрозе его жизни или здоровью может применяться в отношении любых лиц, осуществляющих возложенные на них законом обязанности по его воспитанию, обеспечению достойных условий жизни и т. п.: родителей, усыновителей, опекунов (попечителей), в том числе приемных родителей",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let SemPr20_1_93 = {
	"name": "SemPr20_1_93",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Вправе ли опекун требовать возврата ребенка, удерживаемого его родителем?",
				"correct_ans": [
					{
						"ans": "Да, вправе",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Нет, не вправе",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "В силу п.4 ст. 148.1 СК РФ опекун вправе требовать по суду возврата ребенка, находящегося под опекой, от любых лиц, удерживающих у себя ребенка без законных оснований, в том числе от родителей, удерживающих ребенка вопреки решению органа опеки и попечительства об отобрании у них ребенка"
}

export let SemPr20_1_126 = {
	"name": "SemPr20_1_126",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Какие из перечисленных ниже алиментных обязательств могут исполняться на основании судебного приказа?",
				"correct_ans": [
					{
						"ans": "Обязательства родителей в отношении несовершеннолетних детей",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Вопрос о выплате родителями алиментов в отношении совершеннолетних детей решается в порядке искового производства.",
						"ans": "Обязательства родителей в отношении совершеннолетних детей",
						"score": 0
					},
					{
						"comm": "Вопрос о выплате детьми алиментов в отношении нетрудоспособных родителей решается в порядке искового производства.",
						"ans": "Обязательства детей в отношении нетрудоспособных родителей",
						"score": 0
					},
					{
						"comm": "Вопрос о выплате братьями (сестрами) алиментов в отношении несовершеннолетних братьев (сестер) детей решается в порядке искового производства.",
						"ans": "Обязательства братьев и сестер в отношении несовершеннолетних братьев и сестер",
						"score": 0
					},
					{
						"comm": "Вопрос о выплате бабушкой (дедушкой) алиментов в отношении несовершеннолетних внуков решается в порядке искового производства.",
						"ans": "Обязательства бабушки и дедушки в отношении несовершеннолетних внуков",
						"score": 0
					},
					{
						"ans": "Все перечисленные обязательства",
						"score": 0
					},
					{
						"comm": "Напротив, ГПК РФ прямо закрепляет возможность выдачи судебного приказа, не требующей длительной процедуры судебного разбирательства, для исполнения отдельных алиментных обязательств.",
						"ans": "Алиментные обязательства не могут исполняться на основании судебного приказа",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Выплата алиментов родителей в пользу несовершеннолетних детей, при соблюдении иных условий, предусмотренных законом, может осуществляться на основании судебного приказа. См. абз. 5 ст. 122 ГПК РФ, п.3 Постановления Пленума Верховного Суда РФ от 26.12.2017 № 56"
}

export let SemPr20_1_132 = {
	"name": "SemPr20_1_132",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Какие (какое) из перечисленных ниже видов алиментных обязательств возникают только при условии трудоспособности алиментообязанного лица?",
				"correct_ans": [
					{
						"ans": "Обязательство совершеннолетних детей в отношении родителей",
						"score": 12
					},
					{
						"ans": "Обязательство внуков в отношении дедушек (бабушек)",
						"score": 12
					},
					{
						"ans": "Обязательство братьев (сестер) в отношении братьев (сестер)",
						"score": 12
					},
					{
						"ans": "Обязательство воспитанников в отношении фактических воспитателей",
						"score": 12
					},
					{
						"ans": "Обязательство падчериц (пасынков) в отношении отчима (мачехи)",
						"score": 12
					}
				],
				"wrong_ans": [
					{
						"ans": "Обязательство родителей в отношении несовершеннолетних детей",
						"score": 0
					},
					{
						"ans": "Обязательство родителей в отношении совершеннолетних детей",
						"score": 0
					},
					{
						"ans": "Обязательство дедушек (бабушек) в отношении внуков",
						"score": 0
					},
					{
						"ans": "Обязательство супруга (бывшего супруга) в отношении другого супруга (бывшего супруга)",
						"score": 0
					},
					{
						"ans": "Все перечисленные виды обязательств",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Не зависит от трудоспособности алиментообязанных лиц обязанность по содержанию родителями своих детей (как совершеннолетних, так и несовершеннолетних), супругами (бывшими супругами) в отношении друг друга, а также обязанность дедушки и бабушки в отношении внуков. В остальных случаях трудоспособность является одним из необходимых условий возникновения обязанности по уплате алиментов. См. ст. ст. 80, 85, 89, 90, 95 СК РФ",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let SemPr20_1_165 = {
	"name": "SemPr20_1_165",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Вправе ли суд вынести решение об усыновлении ребенка, находящегося на воспитании в приемной семье, в случае отказа приемных родителей дать согласие на усыновление?",
				"correct_ans": [
					{
						"ans": "Да, вправе",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Согласие приемных родителей на усыновление ребенка, находящегося у них на воспитании, не является обязательным условием для его усыновления.",
						"ans": "Нет, не вправе",
						"score": 0
					},
					{
						"comm": "Согласие приемных родителей на усыновление ребенка, находящегося у них на воспитании, не является обязательным условием для его усыновления. И уж тем более разрешение органа опеки и попечительства не может компенсировать отсутствие согласия приемных родителей.",
						"ans": "Вправе только с разрешения органа опеки и попечительства",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "В соответствии с п. 2 ст. 131 СК РФ суд вправе в интересах ребенка вынести решение об усыновлении без согласия приемных родителей. См. также п .9 Постановления Пленума ВС РФ № 8 от 20.04.2006"
}

export let SemPr20_1_86 = {
	"name": "SemPr20_1_86",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Споры между родителями по поводу выбора фамилии и (или) имени ребенка разрешаются:",
				"correct_ans": [
					{
						"ans": "В судебном порядке, если спор не решен органом опеки и попечительства",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Только в судебном порядке",
						"score": 0
					},
					{
						"ans": "Только органом опеки и попечительства",
						"score": 0
					},
					{
						"comm": "У родителей отсутствует право выбора формы защиты.",
						"ans": "Как в судебном порядке, так и органом опеки и попечительства, по выбору спорящих сторон (родителей)",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "В соответствии с 4 ст. 58 СК РФ спор между родителями о выборе фамилии и (или) имени ребенка разрешаются без судебного вмешательства путем нахождения компромиссного решения с привлечением органов опеки и попечительства. Однако нет никаких оснований ограничивать право родителей за разрешением спора по поводу выбора фамилии и (или) имени ребенка в суде, если исчерпаны иные средства разрешения конфликта"
}

export let SemPr20_1_124 = {
	"name": "SemPr20_1_124",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Вправе ли трудоспособный бывший супруг, получающий пенсию за выслугу лет, требовать предоставления содержания от другого бывшего супруга, брак с которым был расторгнут за два года до возникновения права на получение пенсии?",
				"correct_ans": [
					{
						"ans": "Нет, не вправе",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Получение нуждающимся бывшим супругом пенсии, в том числе за выслугу лет, никоим образом не связано с возникновением у этого лица права на алименты в рассматриваемом случае.",
						"ans": "Да, вправе",
						"score": 0
					},
					{
						"comm": "Подтверждения нуждаемости бывшего супруга недостаточно для возникновения у этого лица права на алименты в рассматриваемом случае.",
						"ans": "Вправе, если подтвердит в судебном порядке свою нуждаемость",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Правом на получение содержания от бывшего супруга обладает нуждающийся бывший супруг, достигший пенсионного возраста не позднее чем через 5 лет с момента расторжения брака, если супруги состояли в браке длительное время. См. абз. 5 п. 1 ст. 90 СК РФ"
}

export let SemPr20_1_142 = {
	"name": "SemPr20_1_142",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "За какой максимально допустимый период могут быть взысканы алименты, уплата которых не производилась по вине плательщика?",
				"correct_ans": [
					{
						"ans": "За весь период неуплаты",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Трехлетний срок установлен для случаев уклонения лица от уплаты алиментов (п. 2 ст. 107 СК РФ).",
						"ans": "Три года, предшествовавшие обращению в суд с требованием о взыскании невыплаченных алиментов",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Срок, в течение которого допускается взыскание задолженности по уплате алиментов, зависит от наличия или отсутствия вины плательщика в образовании такой задолженности. При наличии вины алиментообязанного лица удержание алиментов производится за весь период неуплаты. См. п.,п. 1, 2 ст. 113 СК РФ"
}

export let SemPr20_1_72 = {
	"name": "SemPr20_1_72",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Какова форма брачного договора и каковы правовые последствия ее несоблюдения?",
				"correct_ans": [
					{
						"ans": "Нотариально удостоверенная письменная форма. Несоблюдение формы договора влечет его недействительность (ничтожность)",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Простая письменная. Несоблюдение формы договора влечет его недействительность",
						"score": 0
					},
					{
						"ans": "Простая письменная. Несоблюдение формы договора лишает стороны права в случае спора ссылаться в подтверждение договора и его условий на свидетельские показания, но не лишает их права приводить письменные и другие доказательства",
						"score": 0
					},
					{
						"ans": "Закон не устанавливает обязательной формы брачного договора. Возможна любая, в том числе устная, форма. Как следствие, последствия несоблюдения формы договора не установлены",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Согласно ст. 41 СК РФ брачный договор заключается в письменной форме и подлежит нотариальному удостоверению. Несоблюдение нотариальной формы брачного договора влечет недействительность (ничтожность) брачного договора (п. 1 ст. 165 ГК РФ)"
}

export let SemPr20_1_22 = {
	"name": "SemPr20_1_22",
	"descriprion": "type1",
	"theme": "Семейное право - это отрасль публичного права",
	"title": "Семейное право - это отрасль публичного права",
	"data": {
		"questions": [
			{
				"qst": "Вправе ли беременная супруга требовать расторжения брака в судебном порядке при отсутствии согласия супруга на расторжение брака?",
				"correct_ans": [
					{
						"ans": "Да, вправе",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Нет, не вправе",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Запрет требовать расторжения брака в случае беременности супруги и в течение одного года после рождения ребенка распространяется исключительно на супруга (мужчину). Супруга (женщина) вправе в любое время требовать расторжения брака в предусмотренном законом порядке. См. ст. 17 СК РФ"
}

